import React from 'react';
import { motion } from 'framer-motion';
import { NoirBackground } from '../components/GameUI';
import { ArrowLeft, Instagram, Mail } from 'lucide-react';

const Contact = ({ onBack }) => (
  <div className="min-h-dvh flex flex-col items-center p-6 relative select-none">
    <NoirBackground />
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-md space-y-6 relative z-10 py-8">
      <button onClick={onBack} data-testid="contact-back-btn"
        className="flex items-center gap-2 font-mono text-[#5A5A5A] text-xs uppercase tracking-wider hover:text-[#EF4444] transition-colors">
        <ArrowLeft size={14} /> Back
      </button>
      <div>
        <h1 className="font-typewriter text-4xl text-[#E0DDD5]">Contact</h1>
        <div className="red-line w-full mt-3" />
      </div>
      <div className="space-y-6 text-sm text-[#888] font-mono leading-relaxed">
        <p>Got questions, feedback, or just want to say hello? Reach out through any of the channels below.</p>

        <div className="space-y-4">
          <a href="https://www.instagram.com/henrykunjumon/" target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-4 bg-gradient-to-b from-[#161616] to-[#111] border border-[#222] rounded-lg p-4 hover:border-[#EF4444]/40 transition-colors group"
            data-testid="contact-instagram-link">
            <Instagram size={20} className="text-[#EF4444]" />
            <div>
              <div className="text-[#E0DDD5] font-bold text-sm group-hover:text-[#EF4444] transition-colors">Instagram</div>
              <div className="text-[#5A5A5A] text-xs">@henrykunjumon</div>
            </div>
          </a>

          <a href="mailto:henry.k813050@gmail.com"
            className="flex items-center gap-4 bg-gradient-to-b from-[#161616] to-[#111] border border-[#222] rounded-lg p-4 hover:border-[#EF4444]/40 transition-colors group"
            data-testid="contact-email-link">
            <Mail size={20} className="text-[#EF4444]" />
            <div>
              <div className="text-[#E0DDD5] font-bold text-sm group-hover:text-[#EF4444] transition-colors">Email</div>
              <div className="text-[#5A5A5A] text-xs">henry.k813050@gmail.com</div>
            </div>
          </a>
        </div>

        <div className="bg-gradient-to-b from-[#161616] to-[#111] border border-[#222] rounded-lg p-5 text-center space-y-2">
          <div className="font-typewriter text-xl text-[#E0DDD5]">IMPOSTER</div>
          <div className="text-[#5A5A5A] text-xs">A social deduction party game</div>
          <div className="text-[#333] text-xs">Made with love by Henry Kunjumon</div>
        </div>
      </div>
    </motion.div>
  </div>
);

export default Contact;
